import { keepPreviousData, useQuery } from '@tanstack/react-query'

import { useViewerRegion } from '@/frontend/features/region/region-context'
import { useOsApi } from '@/frontend/hooks/api/use-os-api'

/** Searches the active region's product catalog, optionally filtering by name and status. */
export function useListCatalogProducts(filters?: {
  search?: string
  status?: 'active' | 'archived' | 'all'
}) {
  const api = useOsApi()
  const { region } = useViewerRegion()
  const { search, status } = filters ?? {}

  return useQuery({
    queryKey: ['catalog-products', { search, status, region }],
    placeholderData: keepPreviousData,
    queryFn: async () => {
      const response = await api.get('/products/catalog', {
        query: { search: search || undefined, status, region },
      })
      if (!response.success) throw new Error(response.error.message)
      return response.data.products
    },
  })
}
